var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.computedTag,{tag:"component",staticClass:"atom-label",class:{small: _vm.small}},[(_vm.text)?[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]:_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }